import Icon from '@ant-design/icons';
import * as React from 'react';

const TaskListSvg = () => {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M7.5 6.507a1 1 0 011-1h7a1 1 0 011 1v9a1 1 0 01-1 1h-7a1 1 0 01-1-1v-9z"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 14.507h-2a1 1 0 01-1-1v-9a1 1 0 011-1h7a1 1 0 011 1v1"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 12.507h-2a1 1 0 01-1-1v-9a1 1 0 011-1h7a1 1 0 011 1v1M12.5 8.507h2M9.5 8.007l.5.5 1-1M12.5 11.507h2M9.5 11.007l.5.5 1-1M12.5 14.507h2M9.5 14.007l.5.5 1-1"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const TaskListIcon = (props: any) => (
  <Icon component={TaskListSvg} {...props} />
);

export default TaskListIcon;
